import BaseModel from '../core/BaseModel'
export default class AvailableWeekModel extends BaseModel {

    constructor() {
        super({
                name: "available_week",
                tableName: 'available_week',
                label: "Available week"
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                }
            })
    }

}